var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"400px","padding":"30px","margin":"auto","text-align":"center"}},[_c('pie-chart',{attrs:{"chart-data":_vm.chartData,"styles":_vm.styles,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }